import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function ShopTitle() {
  return <section data-section-id="162035" id="shop-title" className="relative bg-background overflow-hidden py-16 md:py-32 dark">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, var(--background) 1px, transparent 1px), linear-gradient(to bottom, var(--background) 1px, transparent 1px)`,
      backgroundSize: '32px 32px'
    }} aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h1 className="text-6xl md:text-8xl lg:text-[15vw] font-default font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary via-foreground/40 to-primary tracking-tighter uppercase mb-6 leading-none">
          Artifacts
        </h1>

        <Breadcrumb>
          <BreadcrumbList className="text-muted-foreground justify-center sm:justify-center font-default tracking-widest uppercase text-xs">
            <BreadcrumbItem>
              <BreadcrumbLink asChild className="hover:text-primary transition-colors">
                <Link to="#">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-primary/30" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-primary font-medium">Artifacts</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </section>;
}